import * as React from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import {
  PageTitleConstants,
  RoutePathConstants,
  ProcessStatusEnum,
} from "../../Constants";
import { Card } from "react-bootstrap";
import { useState, useEffect, useContext } from "react";
import { updateUserCurrentStep, PageHeader, Loading } from "wup-module1-base";
import UserContext from "../../Contexts/UserContext";
import { ClientService, StoreService } from "../../Services";
import { WindowOffers, WindowLinkExpired } from "../../Components";
import "./Store.css";
import { toast } from "react-toastify";

function StoreExclusive() {
  const nexErrorOfferMessage = "Nie wybrano żadnej oferty";
  const nexErrorBookingMessage = "Nie wybrano terminu spotkania";
  const { uuId } = useParams();
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmittingButton, setIsSubmittingButton] = useState(false);
  const [isActive, setIsActive] = useState(false);

  const [itemsData, setItemsData] = useState();
  const [itemsDataOffer, setItemsDataOffer] = useState();
  const storedData = sessionStorage.getItem("storeData");
  const parsedData = JSON.parse(storedData);

  useEffect(() => {
    setIsLoading(true);
    StoreService.checkLinkIsActive(uuId)
      .then((response) => {
        console.log(response.data.isActive);
        setIsActive(response.data.isActive);
      })
      .catch((error) => {
        setIsActive(false);
        console.error(error);
      })
      .finally(() => {
        setIsLoading(false);
      });


    if (!itemsData) {
      setIsSubmitting(true);
      StoreService.storeItems()
        .then((response) => {
          setItemsData(response.data);
          setItemsDataOffer(response.data.filter((item) => item.type === 2));
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    }
  }, []);

  useEffect(() => {
    if (!!offer) {
      itemsDataOffer?.forEach((item, index2) => {
        document.getElementById(`offer_picture_${index2}`).className =
          "offer-1-gray";
        document.getElementById(`offer_${index2}`).className = "offer-text-1";
      });
    }
  }, [itemsDataOffer]);

  const [offer, setOffer] = useState(
    parsedData === null ? undefined : parsedData.offer
  );

  const [bookingId, setBooking] = useState(
    parsedData === null ? undefined : parsedData.bookingId
  );

  const changeOffer = (index, id) => {
    let box = document.getElementById(`offer_${index}`);

    let picture = document.getElementById(`offer_picture_${index}`);

    if (offer === id) {
      box.className = "offer-text-1";
      itemsDataOffer.forEach((item, index2) => {
        document.getElementById(`offer_picture_${index2}`).className =
          "offer-1";
        document.getElementById(`offer_${index2}`).className = "offer-text-1";
      });
      setOffer();
      changeBooking();
    } else {
      itemsDataOffer.forEach((item, index2) => {
        document.getElementById(`offer_picture_${index2}`).className =
          "offer-1-gray";
        document.getElementById(`offer_${index2}`).className = "offer-text-1";
      });

      box.className = "offer-text-1-selected";
      picture.className = "offer-1";
      setOffer(id);
    }
  };

  const changeBooking = (id) => {
    setBooking(id);
  };

  function goNext() {
    const dataToPass = {
      offer: offer,
      bookingId: bookingId,
    };

    if (
      dataToPass.offer == null ||
      dataToPass.offer == undefined ||
      dataToPass.offer == 0
    ) {
      toast.error(nexErrorOfferMessage);
      return;
    }

    if (
      dataToPass.bookingId == null ||
      dataToPass.bookingId == undefined ||
      dataToPass.bookingId == 0
    ) {
      toast.error(nexErrorBookingMessage);
      return;
    }

    sessionStorage.setItem("storeData", JSON.stringify(dataToPass));

    setIsSubmittingButton(true);
    navigate(`/${RoutePathConstants.StoreExclusiveSummary}/${uuId}`);
  }

  return (
    <>
      {isLoading ? (
        <Loading size="large" className="px-30" variant="dark" />
      ) : (
        <>
          {isActive ? (
            <>
              <PageHeader content={PageTitleConstants.Shop} />
              <Card>
                <Card.Body className="pt-4-5 store-card-body background_1">
                  {isSubmitting ? (
                    <Loading size="lg" className="px-30" variant="dark" />
                  ) : (
                    <div>
                      <div className="text-box1">
                        <div className="text-1">
                          Wybierz z jakich usług chcesz skorzystać
                        </div>
                      </div>

                      <WindowOffers
                        offer={offer}
                        changeOffer={changeOffer}
                        changeBooking={changeBooking}
                        itemsData={itemsDataOffer}
                      />

                      <div className="button-box">
                        <button
                          className="button-check button-100"
                          disabled={isSubmittingButton}
                          onClick={goNext}
                        >
                          {isSubmittingButton ? (
                            <Loading
                              size="sm"
                              className="px-3"
                              variant="light"
                            />
                          ) : (
                            <>Zatwierdzam wybór</>
                          )}
                        </button>
                      </div>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </>
          ) : (
            <WindowLinkExpired />
          )}
        </>
      )}
    </>
  );
}

export default StoreExclusive;
